<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msg" :mensagem="msg" />

    <div class="form-edit-page">
        <form @submit.prevent="submitForm">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Tipo Pessoa</label>
                    <div class="field-label field-label-end">{{ objEdicao.cdtppessoa }}</div>
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Nome</label>
                    <input type="text" v-model="objEdicao.nmtppessoa" required maxlength="100" v-uppercase />
                </div>
            </div>


            <div class="row-end">
                <label for="ckAtivo">Ativo</label>
                <input id="ckAtivo" type="checkbox" class="input-checkbox" v-model="ckAtivo" />
            </div>


            <div class="row-end margin-top10">
                <button class="btn-confirm" type="submit">Salvar</button>
                <button class="btn-cancel" type="cancel" @click="cancelForm">Cancelar</button>
            </div>
        </form>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { criarGabineteTpPessoa } from '@/models/GabineteTpPessoa';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close', 'salvo']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const ckAtivo = ref(false);
const msg = ref(false);
const objEdicao = ref(criarGabineteTpPessoa());
const isLoading = ref(false);

const submitForm = async () => {
    try {
        isLoading.value     = true;
        msg.value=null;
        objEdicao.value.ativo     = ckAtivo.value ? 'S' : 'N';
        const response      = await genericPut('/cad/gabinete_tppessoa', objEdicao.value);
        if (response.bolok === 1){
            emit('salvo');
            emit('close');
        }else{
            msg.value = response.erro;
        }
    } catch (error) {msg.value = error;
    } finally{isLoading.value=false;}
};

const cancelForm = () => {emit('close');};

const lerDados = async() => {
    try{
        isLoading.value=true;
        msg.value=null;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('gabinete_tppessoa', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msg.value = error}
        }else{
            objEdicao.value.idmunicipio = globalStore.idmunicipio;
            objEdicao.value.idlogin     = globalStore.idlogin;
        }
        objEdicao.value.idusuario = globalStore.idusuario;
        ckAtivo.value             = objEdicao.value.ativo === 'S';
    } catch (error) {msg.value = error;
    }finally{isLoading.value=false;}
};

onMounted(lerDados);
</script>